// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const fasColumns3: CreateIconOptions = {
  "displayName": "FASColumns3",
  "viewBox": "0, 0, 640, 512",
  "d": "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l512 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM192 96l0 320L64 416 64 96l128 0zm64 0l128 0 0 320-128 0 0-320zm320 0l0 320-128 0 0-320 128 0z"
};
